// IMPORTANT: Make sure this is in sync with functions/src/index.ts
export enum UNSUBSCRIBE_TYPE {
    mailingList = 'mailing-list',
    commentUpdates = 'comment-updates',
    cartAbandonment = 'cart-abandonment',
}
